import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { BreadcrumbItem } from '../layout/modeles/breadcrumb-item';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private itemsSource = new BehaviorSubject<BreadcrumbItem[]>([]);

  itemsHandler = this.itemsSource.asObservable();

  setItems(items: BreadcrumbItem[]): void {
    if (!items || items.length === 0) {
      this.itemsSource.next([]);
      return;
    }

    // Normalize: keep only accessible pages (have routerLink and not '/'),
    // always keep the last item, and ensure the last item is NOT clickable.
    const lastIndex = items.length - 1;
    const normalized = items.filter((it, idx) => {
      if (idx === lastIndex) return true;
      return it.routerLink !== undefined && it.routerLink !== '/';
    });

    // Force last item non-clickable
    const li = normalized.length - 1;
    if (li >= 0) {
      const last = normalized[li];
      normalized[li] = { ...last, routerLink: undefined };
    }

    this.itemsSource.next(normalized);
  }

  public getItems(): BehaviorSubject<BreadcrumbItem[]> {
    return this.itemsSource;
  }

  // add an item to the breadcrumb
  public appendItem(item: BreadcrumbItem): void {
    const currentItems = this.itemsSource.getValue();
    this.itemsSource.next([...currentItems, item]);
  }

  //replace the last item in the breadcrumb
  public setLastItem(item: BreadcrumbItem): void {
    const currentItems = this.itemsSource.getValue();
    
    if (currentItems.length > 0) {
      currentItems[currentItems.length - 1] = item; // Replace last item in breadcrumb trail
    } else {
      currentItems.push(item); // If empty, just set the item
    }
    
    this.itemsSource.next([...currentItems]); // Update breadcrumbs
  }
}
